export class ResponseModel {
    RefreshToken: string;
    Data: any;

    constructor() {
        this.RefreshToken = '';
        this.Data = undefined;
    }
}